import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from 'app/auth/authRoles'

const DeviceEchart = Loadable(lazy(() => import('./echarts/DeviceEchart')))

const chartsRoute = [
    {
        path: '/wykresy/:type',
        element: <DeviceEchart />,
        auth: authRoles.editor,
    },
]

export default chartsRoute
